
export function DateDiff(date1: Date, date2: Date) {
    let datediff = date1.getTime() - date2.getTime(); //store the getTime diff - or +
    //return (datediff / (24 * 60 * 60 * 1000)); //Convert values to -/+ days and return value      
    return (datediff / (60 * 60 * 1000)); //Convert values to -/+ hours and return value      
}

export function dateFromStrLocal(dtStr: string) {
    let returnDate;
    let day, month, year, hour, minute
    let parts3, parts2, parts
    parts = dtStr.split("-");
    year = parseInt(parts[0], 10);
    month = parseInt(parts[1], 10);
    parts2 = parts[2].split(" ");
    day = parseInt(parts2[0], 10);
    parts3 = parts2[1].split(":");
    hour = parseInt(parts3[0], 10);
    minute = parseInt(parts3[1], 10);
    returnDate = new Date(year, month - 1, day, hour, minute);
    return returnDate;
}

export function dateFromStr(dtStr: string, inputFormat: string, isNotUTC: boolean = false) : Date {
    //new Date(year,month,date[,hour,minute,second,millisecond ])
    //1.year: Integer value representing the year. For compatibility (in order to avoid the Y2K problem), you should always specify the year in full; use 1998, rather than 98.
    //2.month: Integer value representing the month, beginning with 0 for January to 11 for December. 
    //3.date: Integer value representing the day of the month.
    //4.hour: Integer value representing the hour of the day (24-hour scale).
    //5.minute: Integer value representing the minute segment of a time reading.
    //6.second: Integer value representing the second segment of a time reading.
    //7.millisecond: Integer value representing the millisecond segment of a time

    let returnDate;
    let day, month, year, TT, hour, minute
    let parts3, parts2, parts
    switch (inputFormat) {
        case "dd/MM/yyyy hh:mm:ss TT":
            {
                parts = dtStr.split("/");
                day = parseInt(parts[0], 10);
                month = parseInt(parts[1], 10);
                parts2 = parts[2].split(" ");
                if (parts2.length > 1) {
                    year = parseInt(parts2[0], 10);
                    TT = parts2[2];
                    parts3 = parts2[1].split(":");
                    hour = parseInt(parts3[0], 10);
                    if (TT == "PM") {
                        hour = hour + 12;
                    }
                    minute = parseInt(parts3[1], 10);
                    if (isNotUTC) {
                        returnDate = new Date(year, month - 1, day, hour, minute);
                    } else {
                        returnDate = new Date(Date.UTC(year, month - 1, day, hour, minute));
                    }
                    
                } else {
                    if (isNotUTC) {
                        returnDate = new Date(year as any, month - 1, day, 0, 0);
                    } else {
                        returnDate = new Date(Date.UTC(year as any, month - 1, day, 0, 0));
                    }
                    
                }
                break;
            }
        case "yyyy-MM-dd hh:mm:ss":
            {
                parts = dtStr.split("-");
                year = parseInt(parts[0], 10);
                month = parseInt(parts[1], 10);
                parts2 = parts[2].split(" ");
                day = parseInt(parts2[0], 10);
                parts3 = parts2[1].split(":");
                hour = parseInt(parts3[0], 10);
                minute = parseInt(parts3[1], 10);
                if (isNotUTC) {
                    returnDate = new Date(year, month - 1, day, hour, minute);
                } else {
                    returnDate = new Date(Date.UTC(year, month - 1, day, hour, minute));
                }
                
                break;
            }
        case "epoch":
            // Millis from Epoch
        default:
            returnDate = new Date(dtStr);
    }
    return returnDate;
}

export function dateParse(dtStr: string, inputFormat: string, outputFormat: string): string {
    let returnDate;
    returnDate = dateFromStr(dtStr, inputFormat);
    return dateToString(returnDate, outputFormat);
}

export function dateToString(returnDate: Date, outputFormat: string, isUTC=true): string {
    // These get the UTC time, ImageServer queries are returning the local datetime as if it was UTC
    // So this UTC is actually local.

    let curr_year, curr_day, curr_date
    let curr_month, curr_hour, curr_min

    if (isUTC) {
        curr_year = returnDate.getUTCFullYear();
        curr_day = returnDate.getUTCDay();
        curr_date = returnDate.getUTCDate();
        curr_month = returnDate.getUTCMonth() + 1; //Months are zero based
        curr_hour = returnDate.getUTCHours()
        curr_min = returnDate.getUTCMinutes()
    } else {
        curr_year = returnDate.getFullYear();
        curr_day = returnDate.getDay();
        curr_date = returnDate.getDate();
        curr_month = returnDate.getMonth() + 1; //Months are zero based
        curr_hour = returnDate.getHours()
        curr_min = returnDate.getMinutes()
    }
    
    switch (outputFormat) {
        case "ddd":
            {
                return dayOfWeek(curr_day).substring(0, 3);
            }
        case "ddd hh:mm":
            {
                return dayOfWeek(curr_day).substring(0, 3) + " " + pad(curr_hour, 2) + ":" + pad(curr_min, 2);
            }
        case "hh:mm":
            {
                return pad(curr_hour, 2) + ":" + pad(curr_min, 2);
            }
        case "dddd":
            {
                return dayOfWeek(curr_day);
            }
        case "ddd, dd/MM":
            {
                return (dayOfWeek(curr_day)).substring(0, 3) + ", " + curr_date.toString() + "/" + curr_month;
            }
        case "ddd, MMM dd":
            {
                return (dayOfWeek(curr_day)).substring(0, 3) + ", " + (monthOfYear(curr_month)).substring(0, 3) + " " + curr_date.toString();
            }
        case "MMM dd":
            {
                return (monthOfYear(curr_month)).substring(0, 3) + " " + curr_date.toString();
            }
        case "ddd, MMM dd hh:mm":
            {
                return (dayOfWeek(curr_day)).substring(0, 3) + ", " + (monthOfYear(curr_month)).substring(0, 3) + " " + curr_date.toString() + " " + pad(curr_hour, 2) + ":" + pad(curr_min, 2);
            }
        case "dddd, MMMM dd, yyyy":
            {
                return dayOfWeek(curr_day) + ", " + monthOfYear(curr_month) + " " + curr_date.toString() + ", " + curr_year.toString();
            }
        case "ddd, dd MMMM yyyy hh:mm":
            {
                return (dayOfWeek(curr_day)).substring(0, 3) + ', ' + curr_date.toString() + ' ' + monthOfYear(curr_month) + ' ' + curr_year.toString() + '  ' + pad(curr_hour, 2) + ':' + pad(curr_min, 2);
            }
        case "yyyyMMdd":
            {
                return curr_year.toString() + pad(curr_month, 2) + pad(curr_date, 2);
            }
        case "yyyyMMddhhmm":
            {
                return curr_year.toString() + pad(curr_month, 2) + pad(curr_date, 2) + pad(curr_hour, 2) + pad(curr_min, 2);
            }
        case "hh":
            {
                return pad(curr_hour, 2);
            }
        case "dd/MM hh:mm":
            {
                return curr_date.toString() + "/" + curr_month + " " + pad(curr_hour, 2) + ":" + pad(curr_min, 2);
            }
        case "dd/MM/YYYY hh:mm":
            {
                return curr_date.toString() + "/" + curr_month + "/" + curr_year.toString() + " " + pad(curr_hour, 2) + ":" + pad(curr_min, 2);
            }
    }
    return returnDate.toString();
}

export function dayOfWeek(dd: number) : string {
    if (dd > 6) { dd = dd - 7 };
    switch (dd) {
        case 0:
            {
                return "Sunday";
            }
        case 1:
            {
                return "Monday";
            }
        case 2:
            {
                return "Tuesday";
            }
        case 3:
            {
                return "Wednesday";
            }
        case 4:
            {
                return "Thursday";
            }
        case 5:
            {
                return "Friday";
            }
        case 6:
            {
                return "Saturday";
            }
    }
    return "undefined";
}

export function monthOfYear(MM: number) : string {
    switch (MM) {
        case 1:
            {
                return "January";
            }
        case 2:
            {
                return "February";
            }
        case 3:
            {
                return "March";
            }
        case 4:
            {
                return "April";
            }
        case 5:
            {
                return "May";
            }
        case 6:
            {
                return "June";
            }
        case 7:
            {
                return "July";
            }
        case 8:
            {
                return "August";
            }
        case 9:
            {
                return "September";
            }
        case 10:
            {
                return "October";
            }
        case 11:
            {
                return "November";
            }
        case 12:
            {
                return "December";
            }
    }
    return "undefined";
}

export function pad(num: number, size: number) : string {
    let s = "00" + num;
    return s.substring(s.length - size);
}

